module.exports = __webpack_public_path__ + "img/icon-plus-primary.0b515950.svg";